module.exports = __webpack_public_path__ + "6162afdd525b711b60c3ffb4762c588c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/winking-22.png
// module id = 2288
// module chunks = 0